import { useState, useEffect } from "react";
import AuthLayout from "../../../components/layouts/auth";
import AddNotificationChannel from "./partials/add-channel";
import SendNotification from "./partials/send-notification";
import ApiSupport from "../../../lib/api-support";
import { ErrorFlash } from "../../../components/helper/flash-notification";
import TableSkeleton from "../../../components/loader/table-placeholder-loader";
import moment from "moment";

interface NotificationsProp {
    uuid: string;
    slug: string;
    name: string;
    identity_not_verified: boolean;
    no_virtual_account: boolean;
    dormant_account: boolean;
    email_not_verified: boolean;
    phone_number_not_verified: boolean;
    registration_period: string;
    registration_period_from: string;
    registration_period_to: string;
    created_at: string;
    user_count: number;
}

type DataProp = {
    items: NotificationsProp[],
    page: number,
    nextPage: number,
    hasMorePages: boolean,
    totalPages: number,
    total?: number,
};

const ListNotifications = () => {

    const [currentPage, setCurrentPage] = useState<number>(1);

    const [transactions, setTransactions] = useState<NotificationsProp[]>([]);
    
    const [transactionData, setTransactionData] = useState<DataProp | undefined>(undefined);

    const [loadingTransactions, setLoadingTransactions] = useState<boolean>(true);

    const getChannels = async () => {
        setLoadingTransactions(true);
        const getTransactions = await (new ApiSupport()).get('pushNotification/channels');
        setLoadingTransactions(false);
        if (getTransactions === 'error') {
            ErrorFlash('Something went wrong');
            return;
        }

        const data = JSON.parse(getTransactions).data;

        setTransactionData(data);

        setTransactions(data.items);
    }

    useEffect(() => {
        getChannels();
    }, []);

    return (
        <AuthLayout>
            <div>
                <div className="items-center space-y-5 lg:justify-between lg:flex md:flex md:space-y-0">
                    <div className='flex items-center space-x-6'>
                        <h1 className="page-title">Notifications</h1>
                    </div>
                </div>
                <div className="flex flex-wrap gap-4 mt-5">
                    <AddNotificationChannel/>
                    <SendNotification channels={transactions} />
                </div>
                <div className='relative overflow-x-auto'>
                    <table className='mt-10 text-tertiary font-[600] text-[14px] w-full relative z-10 whitespace-nowrap'>
                        <thead>
                            <tr className='border-b border-[#E6EAF0]'>
                                <td className="px-4 py-3">Topic name</td>
                                <td className="px-4 py-3">User count</td>
                                <td className="px-6 py-3">Date created</td>
                                <td className="px-6 py-3">Criteria</td>
                                {/* <td className="px-6 py-3">Action</td> */}
                            </tr>
                        </thead>
                        <tbody>
                            {loadingTransactions && <TableSkeleton numberOfColumns={3} />}
                            {transactions.map((item, index) => (
                                <tr key={index}
                                    className='border-b border-[#E6EAF0] relative'>
                                    <td className="px-4 py-3">{item.name}</td>
                                    <td className="px-4 py-3">{item.user_count}</td>
                                    <td className="px-4 py-3">{moment(item.created_at).format("DD-MM-YYYY")}</td>
                                    <td className="px-4 py-3">
                                        {item.no_virtual_account && <p>No virtual account</p>}
                                        {item.identity_not_verified && <p>Identity not verified</p>}
                                        {item.phone_number_not_verified && <p>Phone number not verified</p>}
                                        {item.email_not_verified && <p>Email not verified</p>}
                                        {item.dormant_account  && <p>Dormant account</p>}
                                        <p>From: {!item.registration_period_from ? '-' : moment(item.registration_period_from).format("DD-MM-YYYY")}</p>
                                        <p>To: {!item.registration_period_to ? '-' : moment(item.registration_period_to).format("DD-MM-YYYY")}</p>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </AuthLayout>
    )
}

export default ListNotifications;